export enum TournamentMatchEventAction {
    CREATE = 'CREATE',
    OPEN = 'OPEN',
    UPDATE = 'UPDATE',
    PARTICIPANT_UPDATE = 'PARTICIPANT_UPDATE',
    HOLD = 'HOLD',
    FINISH = 'FINISH',
    CANCEL = 'CANCEL',
    SHOT = 'SHOT',
    REVEAL = 'REVEAL',
    LIVE = 'LIVE',
}
